// Typelizer digest 6957ad381663d61a9cd21e4043f583e2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /authorization_pending */
  authorizationPending: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/authorization_pending', {}, options),
    method: 'get',
  }),

  /** GET / */
  home: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/', {}, options),
    method: 'get',
  }),
}
